export const reviewSectionStyles = {
	sectionWrapper: {
		display: 'flex',
		flexDirection: 'column'
	},

	sectionHeader: {
		display: 'grid',
		gridTemplateColumns: '0.75fr 1fr 1fr',
		gap: 2,
		alignItems: 'center',
		mb: 1
	},

	sectionTitle: {
		fontSize: '1.25rem',
		fontWeight: 700,
		color: 'text.primary'
	},

	columnHeader: {
		fontSize: '0.875rem',
		fontWeight: 600
	},

	divider: {
		mb: 1
	},

	rowsContainer: {
		display: 'flex',
		flexDirection: 'column'
	}
};
